export default "__VITE_PUBLIC_ASSET__58ed5fb6__"